<template>
  <button
    v-if="text"
    ref="copy"
    v-tippy="{ trigger: 'manual', hideOnClick: false }"
    title="copied!"
    @click="onClick"
    class="copy-btn"
    :class="{ 'copy-btn--plain': plain }"
    :aria-label="label"
    type="button"
  >
    <slot>
      <MtxSvg icon="icon-copy" />
    </slot>
  </button>
</template>

<script>
import copyToClipboard from "@/utils/copyToClipboard"

export default {
  props: {
    text: String,
    plain: Boolean,
    label: {
      type: String,
      default: "copy to clipboard"
    }
  },

  beforeUpdate: function() /* istanbul ignore next */ {
    this.$refs.copy._tippy.disable()
    this.$nextTick(() => this.$refs.copy._tippy.enable())
  },

  methods: {
    onClick(e) {
      const tippy = e.target._tippy
      copyToClipboard(this.text, () => {
        tippy.show()
        setTimeout(() => tippy.hide(), 1500)
        e.target.focus()
      })
    }
  }
}
</script>

<style lang="scss">
.copy-btn {
  min-width: unset;

  &--plain {
    min-width: unset;
    border: unset;
    padding: unset;
    color: inherit;
    background: unset;

    &:hover {
      background: unset;
    }
  }
}
</style>
